import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TableCell from '@material-ui/core/TableCell';

import SubTables from './SubTables';

const composeConfig = (rows, initial) =>
  rows.reduce(
    (res, r) => ({
      ...res,
      rows: res.rows.concat([res.columns.map((col) => r.values[col.id])]),
    }),
    initial
  );

// содержит подтаблицу которая раскрывается по expand
const ExpandedRow = ({ row, columns }) => {
  const subTableConfig = composeConfig(row.subRows, { columns: columns.slice(1), rows: [] });

  return (
    <>
      <TableCell {...row.getToggleRowExpandedProps()}>
        <span>
          <ArrowDropDownIcon viewBox="0 0 16 18" style={{ width: 15, height: 15 }} />
        </span>{' '}
        {row.cells[0].render('Cell')} ({row.subRows.length})
      </TableCell>
      <SubTables config={subTableConfig} />
    </>
  );
};

export default ExpandedRow;
